import { graphql, PageProps } from "gatsby";
import React from "react";

import type { LandingPageQuery } from "../../../graphql-types";
import { default as GlobalHead } from "../../components/head";
import Layout from "../../components/layout";
import SectionsLayout, {
  SectionsLayoutHead,
} from "../../components/Sections/SectionsLayout";
import HardcodedSection from "./HardcodedSection";

export type Props = Pick<PageProps<LandingPageQuery>, "data">;

export default function LandingPage({ data: { landingPage, website } }: Props) {
  /* istanbul ignore next */
  if (!landingPage || !website) {
    throw new Error("Could not query necessary data for LandingPage");
  }
  return (
    <Layout
      absolutePath={landingPage.absolutePath}
      home={website}
      metaDescription={landingPage.metaDescription}
      pageTitle={landingPage.metaTitle}
      pageType="landing"
      fullWidth={true}
      className="pt-4"
    >
      <h1 className="sr-only">{landingPage.title}</h1>
      <SectionsLayout sections={landingPage.sections} />
      <HardcodedSection absolutePath={landingPage.absolutePath} />
    </Layout>
  );
}

export const query = graphql`
  query LandingPage($id: String!) {
    website {
      ...homeFields
    }
    landingPage(id: { eq: $id }) {
      id
      absolutePath
      dmpAttributes
      metaDescription
      metaTitle
      title
      sections {
        ...SectionsLayoutData
      }
    }
  }
`;

export const Head = ({ data: { landingPage, website } }: Props) => {
  /* istanbul ignore next */
  if (!landingPage || !website) {
    throw new Error("Could not query necessary data for LandingPage");
  }
  return (
    <>
      <GlobalHead
        absolutePath={landingPage.absolutePath}
        home={website}
        metaDescription={landingPage.metaDescription}
        pageTitle={landingPage.metaTitle}
        pageType="landing"
        testId="landing-page"
        dmpAttributes={landingPage.dmpAttributes}
        id={landingPage.id}
      />
      <SectionsLayoutHead sections={landingPage.sections} />
    </>
  );
};
